import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Host, Input, OnDestroy, OnInit} from '@angular/core';
import {AppModalService} from 'app/services/appModal.service';
import {Message} from '../../../../../../chat-sdk/src/entities/messages/message';
import {UserModelService} from '../../../../models/user-model.service';
import {WorkerStore} from '../../../../../../chat-sdk/src/api/worker';
import {ChatWrapperComponent} from '../chat-wrapper/item';
import {Subscription} from 'rxjs';


// @todo chat move common to abstract class
@Component({
  selector: 'app-chat-info-message',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatInfoMessageComponent implements OnInit, OnDestroy {
  @Input() message: Message = null;
  workerStore: WorkerStore = null;

  chatWrapper: ChatWrapperComponent;
  cdr: ChangeDetectorRef;

  subs: Subscription[] = [];

  constructor(
    @Host() chatWrapper: ChatWrapperComponent,
    cdr: ChangeDetectorRef,
    private modalService: AppModalService,
    public userService: UserModelService
  ) {
    this.chatWrapper = chatWrapper;
    this.cdr = cdr;
  }

  ngOnInit() {
    this.workerStore = this.message?.user ? this.message?.user?.getWorker() : null;

    if (this.workerStore) {
      this.subs.push(this.workerStore?.updateEvent.subscribe(() => {
        this.cdr.detectChanges();
      }));
    }
    // console.log({message: this.message});
    this.message.registerOnUpdate((type) => {
      // console.log('message update component', this.message, type);

      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.subs.length) {
      this.subs.forEach(item => item.unsubscribe());
    }
  }
}
